import { RouterProvider } from 'react-router-dom'
import { defaultRouter } from './routeConfig'

export function App() {
  return <RouterProvider router={defaultRouter} />
}

export default App
